export const UPDATE_PERSONALINFO_REQUEST = 'PATCH_REQUEST';
export const UPDATE_PERSONALINFO_SUCCESS = 'PATCH_SUCCESS';
export const UPDATE_PERSONALINFO_FAIL = 'PATCH_FAIL';
export const UPDATE_ADDRESS_DATE = 'UPDATE_ADDRESS_DATE';
export const QUANTTY_DAYS_FOR_UPDATE = 90;
